/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Steep_Clear_Pig_GaspInputs */

const fr_steep_clear_pig_gasp = /** @type {(inputs: Steep_Clear_Pig_GaspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement effectué le`)
};

/**

* @param {Steep_Clear_Pig_GaspInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const steep_clear_pig_gasp = /** @type {((inputs?: Steep_Clear_Pig_GaspInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Steep_Clear_Pig_GaspInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_steep_clear_pig_gasp(inputs)
});